import fetchFactory from '../../../utils/fetchFactory'

export const recuperationMontantsFiscaux = (annee: number) => fetchFactory(`/api/montantsFiscaux?annee=${annee}`)